import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appConfigService } from '@app/config';
import { first, map, Observable } from 'rxjs';
import {
  UpravnaStvar,
  UpravniPosao,
  UpravnoPodrucje
} from './upravno_podrucje';

@Injectable()
export class UpravnaStvarService {
  private config = inject(appConfigService);
  private httpClient = inject(HttpClient);
  private apiUrl = `${this.config.apiHost}upravne_stvari`;

  getUpravneStvari(): Observable<UpravnoPodrucje[]> {
    return this.httpClient
      .get<any[]>(this.apiUrl, { withCredentials: true })
      .pipe(
        map((data) =>
          data.map(
            (item) =>
              new UpravnoPodrucje(
                item.id,
                item.naziv,
                item.poslovi
                  ? item.poslovi.map(
                      (posao: any) =>
                        new UpravniPosao(
                          posao.id,
                          posao.naziv,
                          posao.stvari
                            ? posao.stvari.map(
                                (stvar: any) =>
                                  new UpravnaStvar(stvar.id, stvar.naziv)
                              )
                            : []
                        )
                    )
                  : []
              )
          )
        )
      );
  }

  updateUpravneStvar(): Observable<any> {
    return this.httpClient
      .get<any[]>(this.apiUrl + '/update', { withCredentials: true })
      .pipe(first());
  }
}
